export default __webpack_public_path__ + "static/media/45.9711618b.jpg";